import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

let authTokenGetter: (() => Promise<string | null>) | null = null;

export const setAuthTokenGetter = (getter: () => Promise<string | null>) => {
  authTokenGetter = getter;
};

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// Request interceptor - add auth token only
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // Add Bearer token
    if (authTokenGetter) {
      const token = await authTokenGetter();
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - dispatch event for app to handle
      console.error('[API] Unauthorized request - authentication required');
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }

    if (error.response?.status === 403) {
      console.error('[API] Forbidden request - insufficient permissions');
      window.dispatchEvent(new CustomEvent('auth:forbidden'));
    }

    if (error.response?.status >= 500) {
      console.error('[API] Server error:', error.response.status, error.response.data);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
